export class UpdateCloudResourceConfigurationRequest {
    'cdcBackup';
    'inventoryBackup';
    'setDynamoDbPartitions';
    'setDynamoDbBinDurationMinutes';
    'setDynamoDbPartitionItems';
    'setStorageLayerBackupProcessorsPerPartition';
    'setStorageLayerBackupMaxNodes';
    'setStorageLayerPartitionSchemeOverride';
    'setStorageLayerMaxFullBackupInterval';
    'setKeyspacesBinDurationMinutes';
    'setMongoAtlasBinDurationMinutes';
    'setForceEc2NativeBackup';
    'setDbBackupModeCdc';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cdcBackup",
            "baseName": "cdcBackup",
            "type": "UpdateCloudResourceConfigurationRequestCdcBackup",
            "format": ""
        },
        {
            "name": "inventoryBackup",
            "baseName": "inventoryBackup",
            "type": "UpdateCloudResourceConfigurationRequestInventoryBackup",
            "format": ""
        },
        {
            "name": "setDynamoDbPartitions",
            "baseName": "setDynamoDbPartitions",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setDynamoDbBinDurationMinutes",
            "baseName": "setDynamoDbBinDurationMinutes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setDynamoDbPartitionItems",
            "baseName": "setDynamoDbPartitionItems",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setStorageLayerBackupProcessorsPerPartition",
            "baseName": "setStorageLayerBackupProcessorsPerPartition",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setStorageLayerBackupMaxNodes",
            "baseName": "setStorageLayerBackupMaxNodes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setStorageLayerPartitionSchemeOverride",
            "baseName": "setStorageLayerPartitionSchemeOverride",
            "type": "string",
            "format": ""
        },
        {
            "name": "setStorageLayerMaxFullBackupInterval",
            "baseName": "setStorageLayerMaxFullBackupInterval",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setKeyspacesBinDurationMinutes",
            "baseName": "setKeyspacesBinDurationMinutes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setMongoAtlasBinDurationMinutes",
            "baseName": "setMongoAtlasBinDurationMinutes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setForceEc2NativeBackup",
            "baseName": "setForceEc2NativeBackup",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "setDbBackupModeCdc",
            "baseName": "setDbBackupModeCdc",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateCloudResourceConfigurationRequest.attributeTypeMap;
    }
    constructor() {
    }
}
